import React, { useCallback } from "react";
import { Flex, Form, Input, message, Typography } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { SubmitButton } from "@/components/button/submit-button";
import {
  LoginResponseSchema,
  LoginSchema,
} from "@/schemas";
import { publicRequest } from "@/services";
import { useNavigate } from "react-router-dom";
import FlatButton from "@/components/button/button";

const onRequestLogin = async (body: LoginSchema) => {
  try {
    const result = await publicRequest<LoginSchema, LoginResponseSchema>({
      url: "/login",
      method: "POST",
      data: body,
    });

    return result.data;
  } catch (error) {
    console.log(error);
  }
};

const LoginAdmin: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = () => {
    message.success("Submit success!");
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const onLogin = useCallback(() => {
    form
      .validateFields()
      .then(async () => {
        try {
          const body = {
            email: form.getFieldValue("email"),
            password: form.getFieldValue("password"),
          };

          const result = await onRequestLogin(body);
          if (result?.token) {
            await localStorage.setItem("email", form.getFieldValue("email") ?? "");
            await localStorage.setItem("access_token", result?.token ?? "");

            message.success("ログインしました。");

            navigate("/admin", { replace: true });
          } else {
            message.error("ログインに失敗しました。 もう一度お試しください。");
          }
        } catch (error) { }
      })
      .catch(() => {
        onFinishFailed();
      });
  }, [form, navigate]);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        管理機能
      </Typography.Text>

      <Typography.Text style={{ fontSize: 24 }}>ログイン</Typography.Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="メールアドレス"
          rules={[
            { required: true, message: "メールアドレスを再入力してください" },
            { type: "email", message: "メールは無効です。" },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="email"
            placeholder="メールアドレスを入力してください。!"
            prefix={<UserOutlined />}
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="パスワード"
          rules={[
            { required: true, message: "パスワードを再入力してください。" },
            {
              type: "string",
              min: 8,
              message: "パスワードは8文字以上でなければなりません",
            },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="password"
            placeholder="パスワードを入力してください。"
            prefix={<LockOutlined />}
          />
        </Form.Item>
      </Form>
      <Form.Item>
        <SubmitButton
          onClick={onLogin}
          styles={{ width: 360 }}
          form={form}
          title={"ログイン"}
        />
      </Form.Item>

      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={() => {
          navigate("/login-qr-code");
        }}
      >
        Login with QRCode
      </FlatButton>
      <FlatButton
        size="large"
        type="primary"
        style={{ width: 360 }}
        onClick={() => {
          navigate("/admin/login-otp");
        }}
      >
        Login with OTP
      </FlatButton>
    </Flex>
  );
};

export default LoginAdmin;